import "./Projects.css";

function ProjectCard(
  { projectName, projectDescription, imageUrl, projectUrl, apiUrl } // 👈 added apiUrl
) {
  return (
    <div className="project-card">
      <div className="image-container">
        <a
          href={projectUrl}
          className="project-external-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={imageUrl}
            alt={projectName}
            className="project-image"
            loading="lazy"
          />
        </a>
      </div>
      <div className="project-details-container">
        <h2 className="project-heading">{projectName}</h2>
        <p className="project-details">{projectDescription}</p>
        
        <a
          href={projectUrl}
          className="project-live-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          View live
        </a>

        {/* 👇 Only shows if apiUrl exists */}
        {apiUrl && (
          <a
            href={apiUrl}
            className="project-live-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            PokeAPI
          </a>
        )}
      </div>
    </div>
  );
}

export default ProjectCard;
